function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import React from 'react';
import Modal from "semantic-ui-react/dist/es/modules/Modal/Modal.js";
import List from "semantic-ui-react/dist/es/elements/List/List.js";
import isValidHTML from 'is-html';
import { size } from "../../../../utils/size";
import { buildKeyFromStrings } from "../../../../utils/build-key-from-strings";
import { Amenities } from "../../Amenities";
import { Divider } from "../../../elements/Divider";
import { Paragraph } from "../../../typography/Paragraph";
import { Grid } from "../../../layout/Grid";
import { GridColumn } from "../../../layout/GridColumn";
import { Heading } from "../../../typography/Heading";
import { Rating } from "../../../elements/Rating";
import { Slideshow } from "../../../media/Slideshow";
import { HTML } from "../../../general-widgets/HTML";
import { getParagraphMarkup } from "../../../../utils/get-paragraph-markup";
export var getModalContentMarkup = function getModalContentMarkup(amenities, amenitiesConjunctionText, amenitiesHeadingText, description, extraFeatures, features, name, periodText, pricePerPeriod, pricePerPeriodPrefix, ratingNumber, images, isUserOnMobile) {
  return React.createElement(Modal.Content, {
    className: "has-room-type-gallery"
  }, React.createElement(Heading, null, name), !!ratingNumber && React.createElement(Rating, {
    ratingNumber: ratingNumber
  }), React.createElement(Divider, {
    size: "small"
  }), React.createElement(Slideshow, {
    images: images,
    isShowingBulletNavigation: size(images) > 1
  }), !!description ? React.createElement(Grid, null, React.createElement(GridColumn, null, isValidHTML(description) ? React.createElement(HTML, {
    htmlString: description
  }) : getParagraphMarkup(description))) : React.createElement(Divider, {
    size: "small"
  }), React.createElement(List, {
    horizontal: true
  }, [].concat(_toConsumableArray(features), _toConsumableArray(extraFeatures)).map(function (_ref, index) {
    var labelText = _ref.labelText;
    return React.createElement(List.Item, {
      key: buildKeyFromStrings(index, labelText, 'feature')
    }, React.createElement(Paragraph, {
      weight: "heavy"
    }, labelText));
  })), React.createElement(Divider, {
    hasLine: true
  }), !!size(amenities) && React.createElement(Amenities, {
    amenities: amenities,
    amenitiesConjunctionText: amenitiesConjunctionText,
    headingText: amenitiesHeadingText,
    isStacked: isUserOnMobile
  }), React.createElement(Grid, null, React.createElement(GridColumn, {
    verticalAlignContent: "bottom",
    width: 12
  }, React.createElement(Paragraph, null, "".concat(pricePerPeriodPrefix), React.createElement("strong", null, " ".concat(pricePerPeriod, " ")), "".concat(periodText)))));
};